"use client";

import { useEffect } from "react";
import { productCategoryPath } from "@/content/site";

/**
 * Old links (footer, bookmarks, shared URLs) point at `/products#dairy`.
 * Hashes never reach the server, so forward them to the category page here.
 */
export function LegacyHashRedirect({ slugs }: { slugs: string[] }) {
  useEffect(() => {
    const hash = decodeURIComponent(window.location.hash.replace(/^#/, ""));
    if (hash && slugs.includes(hash) && window.location.pathname === "/products") {
      window.location.replace(productCategoryPath(hash));
    }
  }, [slugs]);

  return null;
}
